// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"06991b04","9":"963d1ba6","24":"d4e3c590","188":"46a9c346","787":"14675f11","822":"320dd2e3","833":"4a2d10cd","846":"d0fd30af","983":"a53630e0"}[chunkId] + ".chunk.js";
};